/**
 * @generated SignedSource<<8b777f47882032b0f0cc41f1ad35d759>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateTaskSetInput = {
  globalProjectId: string;
  frequency: string;
  intervalLength?: number | null;
  weekdays?: ReadonlyArray<string> | null;
  monthlyWeekday?: string | null;
  monthlyMode?: string | null;
  dayOfMonth?: number | null;
  weekOrdinal?: number | null;
  seedDate: string;
  boundType: string;
  boundCount?: number | null;
  boundEndDate?: string | null;
  setName: string;
  instanceName: string;
  description?: string | null;
  estimateForecast?: number | null;
  globalRoleId?: string | null;
  globalAssignedPersonId?: string | null;
  globalPhaseId?: string | null;
  globalDeliverableId?: string | null;
  globalStatusColumnId?: string | null;
  globalLabelIds?: ReadonlyArray<string | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createTaskSetMutation$variables = {
  input: CreateTaskSetInput;
};
export type createTaskSetMutation$data = {
  readonly createTaskSet: {
    readonly taskSet: {
      readonly id: string;
      readonly name: string | null;
      readonly frequency: string | null;
      readonly intervalLength: number | null;
      readonly weekdays: ReadonlyArray<string> | null;
      readonly monthlyWeekday: string | null;
      readonly monthlyMode: string | null;
      readonly seedDate: string | null;
      readonly boundType: string | null;
      readonly boundCount: number | null;
      readonly boundEndDate: string | null;
      readonly materialisedTo: string | null;
      readonly instanceCount: number | null;
    } | null;
    readonly project: {
      readonly id: string;
    } | null;
  } | null;
};
export type createTaskSetMutation = {
  variables: createTaskSetMutation$variables;
  response: createTaskSetMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTaskSetPayload",
    "kind": "LinkedField",
    "name": "createTaskSet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskSet",
        "kind": "LinkedField",
        "name": "taskSet",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "frequency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "intervalLength",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "weekdays",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthlyWeekday",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthlyMode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seedDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "boundType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "boundCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "boundEndDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "materialisedTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instanceCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectType",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createTaskSetMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createTaskSetMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "23c62e7c8c60bf25bd4fffcce77c0d7c",
    "id": null,
    "metadata": {},
    "name": "createTaskSetMutation",
    "operationKind": "mutation",
    "text": "mutation createTaskSetMutation(\n  $input: CreateTaskSetInput!\n) {\n  createTaskSet(input: $input) {\n    taskSet {\n      id\n      name\n      frequency\n      intervalLength\n      weekdays\n      monthlyWeekday\n      monthlyMode\n      seedDate\n      boundType\n      boundCount\n      boundEndDate\n      materialisedTo\n      instanceCount\n    }\n    project {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c6870d2408806677c4cb7d28fe0140e";

export default node;
